module.exports = __webpack_public_path__ + "static/media/pinterest-pin.1f787b29.jpg";